import { Box } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';

interface NavLink {
  label: string;
  href: string;
  hash?: string;
}

const navLinks: NavLink[] = [
  { label: 'Features', href: '/', hash: '#features' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'About', href: '/about' },
];

interface NavLinksProps {
  orientation?: 'horizontal' | 'vertical';
  onLinkClick?: () => void;
  color?: string;
  activeColor?: string;
  fontSize?: number;
}

export function NavLinks({
  orientation = 'horizontal',
  onLinkClick,
  color = '#a0a5b5',
  activeColor = '#f0f0f5',
  fontSize = 15,
}: NavLinksProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = (link: NavLink) => {
    if (onLinkClick) onLinkClick();

    if (link.hash) {
      if (location.pathname === '/') {
        const el = document.querySelector(link.hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      } else {
        navigate(link.hash === '#features' ? '/' : link.href);
      }
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: orientation === 'vertical' ? 'column' : 'row',
        gap: orientation === 'vertical' ? 1 : 3,
        alignItems: orientation === 'vertical' ? 'flex-start' : 'center',
      }}
    >
      {navLinks.map((link) => {
        const isActive =
          link.href !== '/' && location.pathname === link.href;

        return (
          <Box
            key={link.label}
            onClick={() => handleClick(link)}
            sx={{
              fontSize,
              fontWeight: 500,
              color: isActive ? activeColor : color,
              cursor: 'pointer',
              transition: 'color 0.2s',
              borderBottom: isActive ? `2px solid #3d7aff` : '2px solid transparent',
              pb: orientation === 'vertical' ? 0 : 0.25,
              '&:hover': { color: activeColor },
            }}
          >
            {link.href === '/' && link.hash ? (
              link.label
            ) : (
              <Box
                component={Link}
                to={link.href}
                sx={{ color: 'inherit', textDecoration: 'none' }}
                onClick={(e: React.MouseEvent) => {
                  if (link.hash) {
                    e.preventDefault();
                    handleClick(link);
                  }
                }}
              >
                {link.label}
              </Box>
            )}
          </Box>
        );
      })}
    </Box>
  );
}
